export default __webpack_public_path__ + "static/media/person-holding-dog.4adaee97.jpg";